import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WorkerImage } from "entities/WorkerImage";

import i18n from "../../i18n";
import { apiCallBegan, ApiCallFailedPayload } from "../api";
import { AppDispatch, AppState } from "../configureStore";
import SliceCollectionBase from "../types/SliceCollectionBase";
import { authHeader } from "../users/auth";

// SLICE //
interface State {
  workerImages: SliceCollectionBase<WorkerImage>;
}

const initialState: State = {
  workerImages: {
    list: [],
    loading: false,
    lastFetch: null,
    error: null
  }
};

const slice = createSlice({
  name: "images",
  initialState,
  reducers: {
    workerImagesRequested: images => {
      images.workerImages.loading = true;
    },
    workerImagesReceived: (
      images,
      action: PayloadAction<{ data: string; extraData: number }>
    ) => {
      images.workerImages.list = [
        ...images.workerImages.list,

        { src: action.payload.data, WorkerId: action.payload.extraData }
      ];
      images.workerImages.loading = false;
      images.workerImages.lastFetch = Date.now();
    },
    workerImagesRequestFailed: (
      images,
      action: PayloadAction<ApiCallFailedPayload>
    ) => {
      images.workerImages.loading = false;
      images.workerImages.error = action.payload;
    }
  }
});

const {
  workerImagesRequested,
  workerImagesReceived,
  workerImagesRequestFailed
} = slice.actions;

export default slice.reducer;

// ACTION CREATORS //
export const loadRelatedWorkerProfileImages =
  (personIds: number[]) =>
  async (dispatch: AppDispatch, getState: () => AppState) => {
    for (const id of personIds) {
      const { list } = getState().entities.images.workerImages;
      if (list.some(image => image.WorkerId === id)) {
        continue;
      }

      const url = "/api/profile/image/" + id;
      await dispatch(
        apiCallBegan({
          url,
          method: "GET",
          headers: {
            ...authHeader(),
            "Content-Type": "image/jpeg",
            "Accept-Language": i18n.language
          },
          onStart: workerImagesRequested.type,
          onSuccess: workerImagesReceived.type,
          onError: workerImagesRequestFailed.type,
          responseType: "blob",
          extraData: id
        })
      );
    }
  };
